import Row from '$tablet-app/src/app/components/Row';
import Text from '$tablet-app/src/app/components/Text';
import RecordImage from '$tablet-app/src/app/images/components/RecordImage';
import { recipeBudgetRatingLabels } from '$tablet-app/src/app/recipes/models';
import { Recipe } from '$tablet-app/src/app/recipes/types';
import { spacing } from '$tablet-app/src/app/theme';
import { Button } from '@akin-home/buttons/native';
import { FC, useState } from 'react';
import { Dimensions, LayoutChangeEvent } from 'react-native';
import styled from 'styled-components/native';
import RecipeSimpleDetail from './RecipeSimpleDetail';

interface RecipeOverviewProps {
  /** The recipe being viewed */
  recipe: Recipe;

  /** Whether the recipe is a favourite */
  isFavourite?: boolean;

  /**
   * Callback for creating a shopping list.
   * This should only be present if the user has no main shopping list.
   */
  onPressFavourite?: () => void;
  onPressSwap?: () => void;
}

const RecipeOverviewView: FC<RecipeOverviewProps> = (props) => {
  const { recipe, isFavourite, onPressFavourite, onPressSwap } = props;

  const [imageWidth, setImageWidth] = useState<number>(
    Dimensions.get('window').width - 50
  );
  const handleImageLayout = ({ nativeEvent }: LayoutChangeEvent) => {
    setImageWidth(nativeEvent.layout.width);
  };

  return (
    <LeftColumn>
      <RecipeImage
        onLayout={handleImageLayout}
        style={{ height: Math.min(0.9 * imageWidth, 350) }}
        record={recipe}
      />

      {onPressFavourite ? (
        <FavouriteButtonContainer>
          <Button
            variant="white"
            icon={isFavourite ? 'heart' : ['far', 'heart']}
            iconColor={isFavourite ? 'red' : undefined}
            onPress={onPressFavourite}
          >
            Favourite
          </Button>
        </FavouriteButtonContainer>
      ) : null}

      <Text variant="h2" weight="semibold">
        {recipe.name}
      </Text>

      <RecipeDetails>
        <RecipeSimpleDetail icon="clock" text={recipe.prepTime?.label} />
        <RecipeSimpleDetail icon="utensils" text={recipe.skillLevel?.label} />

        {recipe.budget ? (
          <RecipeSimpleDetail
            icon={['far', 'dollar-sign']}
            text={recipeBudgetRatingLabels[recipe.budget]}
          />
        ) : null}
      </RecipeDetails>

      {onPressSwap ? (
        <Row>
          <SwapButton icon={['far', 'exchange']} onPress={onPressSwap}>
            Choose for change
          </SwapButton>
        </Row>
      ) : null}

      <Text>{recipe.description}</Text>
    </LeftColumn>
  );
};

const LeftColumn = styled.View`
  flex: 1;
  min-width: 200px;
`;

const RecipeImage = styled(RecordImage)`
  width: 100%;
  border-radius: 20px;
  margin-bottom: ${spacing[3]}px;
`;

const RecipeDetails = styled.View`
  flex-direction: row;
  gap: 24px;
  flex-wrap: wrap;
  margin-bottom: ${spacing[3]}px;
  margin-top: ${spacing[3]}px;
`;

const FavouriteButtonContainer = styled.View`
  position: absolute;
  top: 20px;
  right: 20px;
`;

const SwapButton = styled(Button)``;

export default RecipeOverviewView;
